<script setup lang="ts">
import {
  computed,
  inject,
  nextTick,
  onMounted,
  ref,
  shallowRef,
  watch,
} from 'vue';
import ScBtn from '@/components/common/widget/ScBtn.vue';
import { windows } from '@/components/common/window/Windows';
import ImportProxy from '@/views/management/proxy/import/ImportProxy.vue';
import ScPage from '@/components/common/page/ScPage.vue';
import { WindowTool } from '@/components/common/window/WindowInterface';
import { Modal } from 'ant-design-vue';
import { request } from '@/util/request';
import _ from 'lodash';
import draggable from 'vuedraggable'

const props = defineProps<{
  proxies: any[];
}>();

const renderProxies = computed(() => {
  const res = [...props.proxies];
  for (let i = res.length; i < replaceData.value.length; i++) {
    res.push({});
  }
  return res;
});

const columns = [
  {
    title: '序号',
    dataIndex: 'index',
    align: 'center',
  },
  {
    title: '线路名',
    dataIndex: 'name',
  },
  {
    title: '出口IP/归属地',
    dataIndex: 'address',
  },
];

const dragColumns = [
  {
    title: '拖动',
    dataIndex: 'drag',
    width: 60,
  },
  {
    title: 'ss',
    dataIndex: 'tmpId',
  },
  {
    title: '连接信息',
    dataIndex: 'info',
  },
  {
    title: '出口IP/归属地',
    dataIndex: 'address',
  },
  {
    title: '操作',
    dataIndex: 'operation',
  },
];

let replaceTmpId = 0;
const replaceData = ref<any[]>([]);
replaceData.value = [];

async function importProxy() {
  const id = windows.open({
    content: {
      type: 'component',
      component: shallowRef(ImportProxy),
      props: {
        onSubmit: (items: any[]) => {
          replaceData.value.push(
            ...items.map((i) => ({ ...i, tmpId: replaceTmpId++ }))
          );
          return true;
        },
        selectTagGroup: false,
      },
    },
    title: '导入代理线路',
  });
  await windows.getCloseData(id);
}

const windowTool = inject<WindowTool | false>(WindowTool, false);

async function onSubmit() {
  Modal.confirm({
    title: '确定要进行替换吗？',
    onOk: async () => {
      const updateLength = Math.min(
        props.proxies.length,
        replaceData.value.length
      );
      let res = false;
      if (updateLength > 0) {
        const data = [];
        for (let i = 0; i < updateLength; i++) {
          data.push({
            id: props.proxies[i].id,
            data: _.omit(replaceData.value[i], 'tags'),
          });
        }
        res = await request('management/proxy/batchUpdate', { data });
      }
      if (windowTool) {
        windowTool.close(res);
      }
    },
  });
}

function onCancel() {
  if (windowTool) {
    windowTool.close(false);
  }
}

const drag = ref(false)
</script>

<template>
  <sc-page>
    <div class="index-box">
      <div style="padding: 16px 0">
        用于批量替换代理线路的连接信息
        <br />
        1.导入用于替换的线路信息
        <br />
        2.拖动连接信息与待替换线路对应
        <br />
        3.点击确定完成替换
      </div>
      <div class="form-field">
        <sc-btn
          size="small"
          type="primary"
          text="点击导入线路"
          :handler="importProxy"
        />
      </div>
      <!--      <div class="tabs">-->
      <!--        <div class="tab">-->
      <!--          <div class="tab-title">待替换线路</div>-->
      <!--          <a-table-->
      <!--            :dataSource="renderProxies"-->
      <!--            :columns="columns"-->
      <!--            :pagination="false"-->
      <!--            size="small"-->
      <!--            :bordered="true"-->
      <!--            rowKey="tmpId"-->
      <!--          >-->
      <!--            <template #bodyCell="{ record, column, index }">-->
      <!--              <template v-if="column.dataIndex === 'index'">-->
      <!--                {{ index + 1 }}-->
      <!--              </template>-->
      <!--              <template v-if="column.dataIndex === 'info'">-->
      <!--                <div>-->
      <!--                  <span style="color: #1da57a">{{ record.username }}</span>-->
      <!--                  <span> | </span>-->
      <!--                  <span-->
      <!--                    >{{ record.type }}://{{ record.host }}:{{-->
      <!--                      record.port-->
      <!--                    }}</span-->
      <!--                  >-->
      <!--                </div>-->
      <!--              </template>-->
      <!--              <template v-if="column.dataIndex === 'address'">-->
      <!--                <template v-if="record.id">-->
      <!--                  {{ record.outIp || ' - ' }} | {{ record.area || ' - ' }}-->
      <!--                </template>-->
      <!--                <template v-else>-->
      <!--                  <span> &nbsp;</span>-->
      <!--                </template>-->
      <!--              </template>-->
      <!--            </template>-->
      <!--          </a-table>-->
      <!--        </div>-->
      <!--        <div class="tab sortable">-->
      <!--          <div class="tab-title">拖动可以调整顺序</div>-->
      <!--          <a-table-->
      <!--            :dataSource="replaceData"-->
      <!--            :columns="dragColumns"-->
      <!--            :pagination="false"-->
      <!--            size="small"-->
      <!--            :bordered="true"-->
      <!--            rowKey="key"-->
      <!--          >-->
      <!--            <template #emptyText> 请先导入线路</template>-->
      <!--            <template #bodyCell="{ column, record, index }">-->
      <!--              <template v-if="column.dataIndex === 'drag'">-->
      <!--                <div class="drag-handle">☰</div>-->
      <!--              </template>-->
      <!--              <template v-if="column.dataIndex === 'info'">-->
      <!--                <div>-->
      <!--                  <span style="color: #1da57a">{{ record.username }}</span>-->
      <!--                  <span> | </span>-->
      <!--                  <span-->
      <!--                    >{{ record.type }}://{{ record.host }}:{{-->
      <!--                      record.port-->
      <!--                    }}</span-->
      <!--                  >-->
      <!--                </div>-->
      <!--              </template>-->
      <!--              <template v-if="column.dataIndex === 'address'">-->
      <!--                {{ record.outIp || ' - ' }} | {{ record.area || ' - ' }}-->
      <!--              </template>-->
      <!--              <template v-if="column.dataIndex === 'operation'">-->
      <!--                <sc-btn-->
      <!--                  size="small"-->
      <!--                  type="link"-->
      <!--                  text="删除"-->
      <!--                  :handler="() => replaceData.splice(index, 1)"-->
      <!--                />-->
      <!--              </template>-->
      <!--            </template>-->
      <!--          </a-table>-->
      <!--        </div>-->
      <!--      </div>-->

      <div class="tabs">
        <div class="tab">
          <div class="tab-title">待替换线路</div>
          <div class="ant-table ant-table-small ant-table-bordered">
            <div class="ant-table-container">
              <div class="ant-table-content">
                <table style="table-layout: auto">
                  <colgroup></colgroup>
                  <thead class="ant-table-thead">
                    <tr>
                      <th
                        class="ant-table-cell"
                        colstart="0"
                        colend="0"
                        style="text-align: center"
                      >
                        序号
                      </th>
                      <th class="ant-table-cell" colstart="1" colend="1">
                        线路名
                      </th>
                      <th class="ant-table-cell" colstart="2" colend="2">
                        出口IP/归属地
                      </th>
                    </tr>
                  </thead>
                  <tbody class="ant-table-tbody">
                    <tr
                      class="ant-table-row ant-table-row-level-0"
                      v-for="(record, index) in renderProxies"
                      :key="index"
                    >
                      <td class="ant-table-cell" style="text-align: center">
                        {{ index + 1 }}
                      </td>
                      <td class="ant-table-cell">
                        {{ record.name }}
                      </td>
                      <td class="ant-table-cell">
                        <div v-if="record.id">
                          <span style="color: #1da57a">{{
                            record.username
                          }}</span>
                          <span> | </span>
                          <span
                            >{{ record.type }}://{{ record.host }}:{{
                              record.port
                            }}</span
                          >
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="tab sortable">
          <div class="tab-title">拖动可以调整顺序</div>
          <div class="ant-table ant-table-small ant-table-bordered">
            <div class="ant-table-container">
              <div class="ant-table-content">
                <table style="table-layout: auto">
                  <colgroup></colgroup>
                  <thead class="ant-table-thead">
                    <tr>
                      <th
                        class="ant-table-cell"
                        colstart="0"
                        colend="0"
                        style="text-align: center"
                      >
                        序号
                      </th>
                      <th class="ant-table-cell" colstart="1" colend="1">
                        线路名
                      </th>
                      <th class="ant-table-cell" colstart="2" colend="2">
                        出口IP/归属地
                      </th>
                    </tr>
                  </thead>
                  <draggable
                    class="ant-table-tbody"
                    tag="tbody"
                    v-model="replaceData"
                    item-key="id">
                    <template #item="{element: record}">
                      <tr
                        class="ant-table-row ant-table-row-level-0"
                      >
                        <td class="ant-table-cell" style="text-align: center">
                          <div class="drag-handle">☰</div>
                        </td>
                        <td class="ant-table-cell">
                        <span style="color: #1da57a">{{
                            record.username
                          }}</span>
                          <span> | </span>
                          <span
                          >{{ record.type }}://{{ record.host }}:{{
                              record.port
                            }}</span
                          >
                        </td>
                        <td class="ant-table-cell">
                          {{ record.outIp || ' - ' }} | {{ record.area || ' - ' }}
                        </td>
                        <td class="ant-table-cell">
                          <sc-btn
                            size="small"
                            type="link"
                            text="删除"
                            :handler="() => replaceData.splice(index, 1)"
                          />
                        </td>
                      </tr>
                    </template>
                  </draggable>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="form-btn-group">
      <sc-btn :handler="onSubmit" text="确定" type="primary" />
      <sc-btn :handler="onCancel" style="margin-left: 10px" text="取消" />
    </div>
  </sc-page>
</template>

<style scoped lang="scss">
.index-box {
  flex-grow: 1;
  overflow: auto;
  padding: 0 16px 16px;

  .tabs {
    display: flex;
    flex-direction: row;

    .tab {
      flex-grow: 1;

      .tab-title {
        padding: 12px 0;
      }
    }
  }
}

.form-btn-group {
  border-top: 1px solid $color-content-border;
  padding: $spacing-medium;
}

.drag-handle {
  width: 100%;
  height: 100%;
  text-align: center;
  cursor: grab;
}
</style>
